import './siteAccess.css';

const cookieName = 'inteloptics_site_access';
const hasAccess = () => document.cookie.split('; ').includes(`${cookieName}=granted`);

export async function requireSiteAccess(container: HTMLElement, projectId: string): Promise<void> {
    container.hidden = false;
    if (projectId !== 'inteloptics-dev' || hasAccess())
        return;
    container.innerHTML = `<main class="site-access"><section class="site-access-panel">
        <div class="site-access-logo">IO</div><h1>IntelOptics Insights</h1>
        <p>Enter the site password to continue.</p><form>
        <label for="site-password">Site password</label>
        <input id="site-password" type="password" autocomplete="current-password" required autofocus>
        <p class="site-access-error" role="alert" hidden>Incorrect password.</p>
        <button type="submit">Continue</button></form></section></main>`;
    const form = container.querySelector('form')!;
    const input = container.querySelector('input')!;
    const error = container.querySelector<HTMLElement>('[role="alert"]')!;
    input.focus();
    await new Promise<void>(resolve => {
        form.addEventListener('submit', event => {
            event.preventDefault();
            if (input.value !== 'inteloptics') {
                error.hidden = false;
                return;
            }
            document.cookie = `${cookieName}=granted; Path=/; Max-Age=315360000; SameSite=Strict${location.protocol === 'https:' ? '; Secure' : ''}`;
            container.replaceChildren();
            resolve();
        });
        input.addEventListener('input', () => error.hidden = true);
    });
}
